<script setup>
    import Store from '../store';
    import TabView from 'primevue/tabview';
    import TabPanel from 'primevue/tabpanel';
    import Button from 'primevue/button';
    import { ref, onBeforeMount, onMounted } from 'vue';
    import dialogs from '../lib/dialogs';
    import api from '../lib/serverApi';
    import utils from '../lib/utils';

    const systemInfo = ref({});

    async function readSystemInfo() {
        try {
            systemInfo.value = await api.getSystemInfo();
            systemInfo.value.dateTime = utils.timeToString(systemInfo.value.dateTime);
        } catch(error) {
            dialogs.showException(error);
        }
    }

    onBeforeMount(() => {
        Store.commit('SET_FORM_HEADER', 'Система');
    });

    onMounted(() => {
        readSystemInfo();
    });

    function updateSelect() {
        document.querySelector('#file-input').click();
    }

    async function onFWUpdatte() {
        const fileInput = document.querySelector('#file-input');
        if (fileInput.files.length !== 1) {
            await dialogs.showError('Не выбран файл обновления!');
            return;
        }

        if (!(await dialogs.confirmDialog(`Начать обновление "${fileInput.files[0].name}"?`))) return;

        const fd = new FormData();
        fd.append('update', fileInput.files[0]);
        try {
            await api.uploadFilesToserver(fd);
            const res = await api.startFWUpdate(fileInput.files[0].name);
            if (res) dialogs.showInfo('Процесс обновления запущен');
            else dialogs.showInfo('Не удалось запустить обновление');
        } catch (error) {
            dialogs.showException(error);
        }
    }

</script>

<template>
    <div class="formPanel">
        <TabView>
            <TabPanel header="Информация о системе">
                <div class="field grid border-bottom-1 surface-border h-3rem">
                    <label class="col-fixed w-15rem">Операционная система</label>
                    <label class="col-fixed font-bold">{{ systemInfo.osType }} - {{ systemInfo.osArch }}</label>
                </div>
                <div class="field grid border-bottom-1 surface-border h-3rem">
                    <label class="col-fixed w-15rem">Всего памяти</label>
                    <label class="col-fixed font-bold">{{ systemInfo.totalmem }}</label>
                </div>
                <div class="field grid border-bottom-1 surface-border h-3rem">
                    <label class="col-fixed w-15rem">Свободная память</label>
                    <label class="col-fixed font-bold">{{ systemInfo.freemem }}</label>
                </div>
                <div class="field grid border-bottom-1 surface-border h-3rem">
                    <label class="col-fixed w-15rem">Время работы (с)</label>
                    <label class="col-fixed font-bold">{{ systemInfo.uptame }}</label>
                </div>
                <div class="field grid border-bottom-1 surface-border h-3rem">
                    <label class="col-fixed w-15rem">Средняя загрузка</label>
                    <label class="col-fixed font-bold">{{ systemInfo.loadavg }}</label>
                </div>
                <div class="field grid border-bottom-1 surface-border h-3rem">
                    <label class="col-fixed w-15rem">Время сервера</label>
                    <label class="col-fixed font-bold">{{ systemInfo.dateTime }}</label>
                    <div class="ml-auto">
                        <Button size="small" @click="readSystemInfo" style="width: 8rem; display: table-cell; vertical-align: middle;">Обновить</Button>
                    </div>
                </div>
                <div class="field grid border-bottom-1 surface-border h-3rem">
                    <label class="col-fixed w-15rem">Версия ПО</label>
                    <label class="col-fixed w-15rem font-bold">{{ systemInfo.versionFW }}</label>
                    <div class="ml-auto">
                        <input id="file-input" type="file" style="display: none;" accept=".zip" @change="onFWUpdatte">
                        <Button size="small" @click="updateSelect" severity="warning" style="width: 8rem; display: table-cell; vertical-align: middle;">Обновить ПО</Button>
                    </div>
                </div>
            </TabPanel>
            <TabPanel header="Процессы">

            </TabPanel>
        </TabView>
    </div>
</template>

<style scoped>
</style>